import React, { useEffect } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from './assets/district-info.module.scss';
import InfoItem from 'src/components/InfoItem';
import { IDistrict } from 'src/types/district';
import { RouteComponentProps } from 'react-router';
import RoleLayout from '../../../../../../components/layout/RoleLayout';
import RenderFile from 'src/components/RenderFile';
import Breadcrumbs from '../../../../../../components/Breadcrumbs';

export interface StateProps {
    files: any;
    district: Partial<IDistrict> | null;
}

export interface DispatchProps {
    getFiles: (id: string | number) => void;
    getData: (id: string | number) => void;
}

interface RouteParams {
    id: string;
}

export interface OwnProps extends RouteComponentProps<RouteParams> {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const DistrictInfo: React.FunctionComponent<Props> = ({
    district,
    getFiles,
    getData,
    files,
    match: {
        params: { id },
    },
}: Props) => {
    useEffect(() => {
        if (id) {
            getFiles(id);
            getData(id);
        }
        // eslint-disable-next-line
    }, [getData, getFiles, id]);

    if (!district) {
        return null;
    }
    const { email, name, phone, contact, address } = district;

    const previewFiles =
        files &&
        files.map((file: any, i: number) => (
            <li style={{ listStyleType: 'none' }} key={file.attach}>
                <a rel="noopener noreferrer" target="_blank" href={`${file.attach}`}>
                    <RenderFile file={file} />
                </a>
            </li>
        ));
    return (
        <RoleLayout>
            <Breadcrumbs
                items={[
                    { name: 'DISTRICTS', path: routes.DISTRICTS_LIST },
                    { name: `${name ? name : ''}`, path: '' },
                ]}
            />
            <div className={classNames(styles.infoWrap)}>
                <div className={classNames(styles.infoItems)}>
                    <InfoItem title={'Full Name:'} value={name} />
                    <InfoItem title={'Email:'} value={email ? email : ''} />
                    <InfoItem title={'Address:'} value={address ? address : ''} />
                    <InfoItem title={'Contact Person:'} value={contact ? contact : ''} />
                    <InfoItem title={'Phone Number:'} value={phone ? phone : ''} />
                    <InfoItem title={'Documents:'} value={previewFiles} />
                </div>
                <div>
                    <Link
                        className={classNames('btn', 'btn-outline-secondary')}
                        to={Router.generate(routes.DISTRICT_EDIT, { id })}
                    >
                        EDIT
                    </Link>
                </div>
            </div>
        </RoleLayout>
    );
};

export default DistrictInfo;
